import { render, staticRenderFns } from "./DBase.vue?vue&type=template&id=b5f26f5c&scoped=true&"
import script from "./DBase.vue?vue&type=script&lang=js&"
export * from "./DBase.vue?vue&type=script&lang=js&"
import style0 from "./DBase.vue?vue&type=style&index=0&id=b5f26f5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f26f5c",
  null
  
)

export default component.exports